import { render } from "./pay_installment.vue?vue&type=template&id=73f2cae2"
import script from "./pay_installment.vue?vue&type=script&lang=js"
export * from "./pay_installment.vue?vue&type=script&lang=js"

import exportComponent from "D:\\SchoolManagement-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__